import { createContext, Dispatch, SetStateAction, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import Search from "./pages/Search/Search";
import Home from "./pages/Home";
import ResultDetail from "./pages/ResultDetail";
import NotFound from "./pages/NotFound";
import About from "./pages/About";
import SurveyPrompt from "./components/SurveyPrompt";
import { useIdleMonitor } from "./utils/idleMonitor";
import N988line from "./pages/n988line";


/* call for all lookup tables
https://api.dev.profile.cocaredirectory.com/v1/lookup-tables?language=en&IncludeAccessibilitySupports=true&IncludeCareSettings=true&IncludeLanguages=true&IncludePatientAgeGroups=true&IncludePatientCommunities=true&IncludePaymentTypes=true&IncludeRaes=true&IncludeServiceCategories=true&IncludeServicesProvided=true&IncludeTelehealthOptions=true
*/

const TRIGGER_EVENT_THRESHOLD = 2;

export const SurveyTriggerContext = createContext<{
  incrementTriggerEventCount: () => void;
}>({ incrementTriggerEventCount: () => { } });
  
type CrisisContextProps = {
  crisisSelectedValues: string[];
  setCrisisSelectedValues: Dispatch<SetStateAction<string[]>>;
};

export const CrisisContext = createContext<CrisisContextProps>({
  crisisSelectedValues: [], setCrisisSelectedValues: () => {}
});

function App() {

  useIdleMonitor();

  const [_, setCount] = useState(0);
  const [shouldShowSurvey, setShouldShowSurvey] = useState(false);
  const [isOpen, setIsOpen] = useState(false); // for contact modal
  
  const [crisisSelectedValues, setCrisisSelectedValues] = useState<string[]>([]);

  return (
    <main className="App">
      <SurveyTriggerContext.Provider
        value={{
          incrementTriggerEventCount: () => {
            setCount((count) => {
              if (count === TRIGGER_EVENT_THRESHOLD - 1)
                setShouldShowSurvey(true);
              return count + 1;
            });
          },
        }}
      >

        <SurveyPrompt
          shouldShowSurvey={shouldShowSurvey}
        />
      {/* <PupDataProvider searchFilters={searchFilters}> */}
        <CrisisContext.Provider value={{
          crisisSelectedValues: crisisSelectedValues,
          setCrisisSelectedValues: setCrisisSelectedValues, 
        }}>
          <Routes>
            <Route path="/" element={<Layout isOpen={isOpen} setIsOpen={setIsOpen} />}>
              <Route index element={<Home isOpen={isOpen} setIsOpen={setIsOpen} />} />
              <Route path="search" element={<Search />} />
              <Route path="result/:resultId" element={<ResultDetail />} />
              <Route path="result/988-line" element={<N988line />} />
              <Route path="about" element={<About isOpen={isOpen} setIsOpen={setIsOpen} />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </CrisisContext.Provider>
        {/* </PupDataProvider> */}
      </SurveyTriggerContext.Provider>
    </main>
  );
}

export default App;
